<template>
  <div class="page">

    <div class="fixed-top bg-white flex justify-around">

      <!--   审核状态选择   -->
      <div class="toolbar van-hairline--bottom">
        <div class="tool-item btn-select-sort " @click="clerkPostCheckStatusSheet.show = true">审核状态：{{ clerkPostCheckStatus }}<span
            class="caret"></span></div>
      </div>

      <!--   店员选择   -->
      <div class="toolbar van-hairline--bottom">
        <div class="tool-item btn-select-sort " @click="clerkSheet = true">店员：{{ clerkSheetName }}<span
            class="caret"></span></div>
      </div>
    </div>

    <van-list
        class="list-style"
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="loadData"
    >
      <div class="dynamic" v-for="(item,index) in list" :key="index">
        <div class="dynamic-head">
          <div class="dynamic-img">
            <img :src="item.avatarUrl">
          </div>
          <div class="information">
            <div>
              <div class="dynamic-name">{{ item.clerkName }}</div>
              <div class="dynamic-sex">
                <span class="men" v-if="item.sex == $store.state.ClerkSexEnum.MEN.value">♂</span>
                <span class="women" v-if="item.sex == $store.state.ClerkSexEnum.WOMEN.value">♀</span>
              </div>
            </div>
            <div>
              <div class="dynamic-date">{{ formatDate(item.createdTime, 'YYYY-MM-DD HH:mm') }}</div>
            </div>
          </div>
          <div style="float: right; margin: 10px 5px;"  >
            <van-tag v-if="item.clerkPostCheckStatus == 0" plain type="warning">待审核</van-tag>
            <van-tag v-if="item.clerkPostCheckStatus == 1" plain type="success">已通过</van-tag>
            <van-tag v-if="item.clerkPostCheckStatus == -1" plain>不通过</van-tag>
            <van-tag v-if="item.clerkPostCheckStatus == null" plain color="#a0d911">无需审核</van-tag>
          </div>
        </div>
        <div class="dynamic-body">
          <div class="script" v-if="item.content">
            <span>{{ item.content }}</span>
          </div>
          <div v-if="item.photoUrls.length > 0">
            <van-image v-for="(img,index) in item.photoUrls"
                       :key="index"
                       style="margin-right:2%"
                       width="100"
                       height="100"
                       fit="contain"
                       :src="img"
                       @click="HandleclickImg(item.photoUrls,index)"
            />
          </div>
          <div v-show="item.videoUrl">
            <video width="100%" height="200px" :src="item.videoUrl" controls="controls" @play="handlePlay(index)"></video>
          </div>
          <div v-if="item.audioUrl">
            <div class="audio-player" :class="player.id == item.id ? 'playing' : ''"
                 @click.prevent.stop="playAudio(item.id, item.audioUrl)">
              <div class="audio">
                <div class="play-tubiao align-center"><van-icon :name="player.id == item.id ? 'pause' : 'play'" class="play-a"/></div>
                <img class="wave" src="/static/images/19/play.png" width="10">
                <div class="duration">{{ formatAudioDuration(item.audioDuration) }}</div>
              </div>
            </div>
          </div>
        </div>
        <div :class="item.clerkPostCheckStatus == 1 || item.clerkPostCheckStatus == null ? 'flex justify-between align-center' : 'flex justify-end align-center'">
          <div v-if="item.clerkPostCheckStatus == 1 || item.clerkPostCheckStatus == null">
            <span>点赞数：{{ item.likeCount }}</span>
          </div>
          <div class="dynamic-follow" style="margin-right: 10px; float: right;color: #07c160;border: 1px solid #07c160;" v-if="item.clerkPostCheckStatus == 0"
               @click="clerkPost(item)">
            <span>审核</span>
          </div>
        </div>
      </div>
    </van-list>

    <!--上拉选择动态状态-->
    <van-action-sheet
        v-model="clerkPostCheckStatusSheet.show"
        :actions="clerkPostCheckStatusSheet.actions"
        cancel-text="取消"
        @select="onClerkPostCheckStatusSheetChange"/>

    <!--上拉选择店员选择-->
    <van-popup v-model="clerkSheet" position="bottom">
      <van-search v-model="search" placeholder="请输入搜索店员" />
      <div class="clerkBox" v-for="(item,index) in clerkAllList" :key="index" @click="clerkClickList(item.id,item.name)">{{item.name}}</div>
    </van-popup>

    <!--  审核  -->
    <van-dialog v-model="clerkPostShow" title="审核备注" show-cancel-button :before-close="clerkPostConfirm"
                confirm-button-text="通过" cancel-button-text="不通过" :overlay="true" :close-on-click-overlay="true"
    >
      <van-field
          v-model="clerkPostReason"
          rows="2"
          autosize
          type="textarea"
          maxlength="100"
          placeholder="审核备注"
          show-word-limit
      />
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {ActionSheet,Button,Image as VanImage, Cell, CellGroup, Panel, Popup, Tab, Tabs, Tag, Toast, Dialog, Field, Search, Icon, List, ImagePreview} from 'vant';
import {getClerkPostCheckList, checkPost} from '@/api/admin/post'
import moment from "moment";
import Decimal from "decimal.js";
import {getClerkList} from "@/api/leader/leader";

Vue.use(VanImage)
    .use(ActionSheet)
    .use(Button)
    .use(Panel)
    .use(Popup)
    .use(Tab)
    .use(Tabs)
    .use(Tag)
    .use(Cell)
    .use(CellGroup)
    .use(Search)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Icon)
    .use(List)
    .use(ImagePreview)

export default {
  name: 'clerk-post-check-list',
  data() {
    return {
      videoElement: [],
      list: [],
      clerkAllList: [],
      loading: false,
      listFinished: false,
      clerkPostShow: false,
      status: 0,
      clerkPostCheckStatusSheet: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '待审核', value: 0},
          {name: '已通过', value: 1},
          {name: '未通过', value: -1},
        ]
      },
      clerkSheet: false,
      clerkName: null,
      clerkId: null,
      clerkPostCheckId: null,
      clerkPostReason: null,
      search: '',
      pageNo: 1,
      pageSize: 10,
      player: {
        id: null,
        audio: null
      }
    }
  },
  computed: {
    clerkPostCheckStatus(){
      if (this.status == 0) {
        return "待审核"
      }
      if (this.status == 1) {
        return "已通过"
      }
      if (this.status == -1) {
        return "不通过"
      }
      return "全部"
    },
    clerkSheetName(){
      if (this.clerkName != null) {
        return this.clerkName
      }
      return "全部"
    }
  },
  methods: {
    clerkPost(item){
      this.clerkPostCheckId = item.clerkPostCheckId
      this.clerkPostReason = item.remark
      this.clerkPostShow = true
    },
    clerkPostConfirm(action, done) {
      if((action == 'confirm' ||action == 'cancel') && this.status != 0) {
        Dialog.alert({
          title: '动态已审核，请勿重复审核'
        })
        done()
        this.loadData(true)
        return
      }
      if (action == 'confirm' || action == 'cancel') {
        //这里是通过
        checkPost(this.clerkPostCheckId, action == 'confirm' ? 1 : -1, this.clerkPostReason).then(res => {
          const data = res.data
          if (data.code == 0) {
            Dialog.alert({
              title: '审核成功'
            })
            this.loadData(true)
            done()
          } else {
            Dialog.alert({
              title: '审核失败',
              message: data.msg
            })
            done()
          }
        })
      }else {
        done()
      }
    },
    clerkList(){
      getClerkList(
          this.search
      ).then(res => {
        const data = res.data
        if (data.code == 0) {
          this.clerkAllList = data.list
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    onClerkPostCheckStatusSheetChange(item) {
      this.status = item.value
      this.clerkPostCheckStatusSheet.show = false
      this.loadData(true)
    },
    clerkClickList(id,name){
      this.clerkName = name
      this.clerkId = id
      this.clerkSheet = false
      this.loadData(true)
    },
    loadData(resetFirstPage) {
      Toast.loading({
        overlay: true,
        message: '加载中...'
      })
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      getClerkPostCheckList(this.clerkId, this.status, this.pageNo, this.pageSize).then(res => {
        Toast.clear()
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
      this.videoElement = document.getElementsByTagName('video')
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    playAudio(id, audioUrl) {
      if (this.player.audio != null) {
        this.player.audio.pause()
      }
      if (this.player.id == id) {
        this.player.id = null
        this.player.audio = null
      } else {
        const videoElement = this.videoElement
        for (let i = 0; i < videoElement.length; i++) {
          this.videoElement[i].pause()
        }
        const audio = new Audio(audioUrl)
        audio.play()
        // 播放结束事件
        audio.onended = () => {
          this.player.id = null
          this.player.audio = null
        }
        this.player.id = id
        this.player.audio = audio
      }
    },
    formatAudioDuration(duration) {
      if (duration != null) {
        duration = Decimal.div(duration, 1000).toFixed(0)
        if (duration.length < 2) {
          duration = '0' + duration
        }
        return duration + '"'
      }
      return ''
    },
    HandleclickImg(photoUrls,index){
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    },
    handlePlay (index) {
      const videoElement = this.videoElement
      if (videoElement && videoElement.length > 0) {
        for (let i = 0; i < videoElement.length; i++) {
          if ( i === index) {
            this.videoElement[i].play()
            this.player.id = null
            this.player.audio = null
          } else {
            this.videoElement[i].pause()
          }
        }
      }
    }
  },
  watch: {
    search: function () {
      this.clerkList()
    }
  },
  mounted() {
    this.clerkList()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-top: 44px;
  padding-bottom: 100px;
}

.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  .toolbar {
    height: 44px;
    font-size: 14px;
    background: #fff;
    position: relative;
    display: flex;

    .tool-item {
      position: relative;
      padding: 12px 0;
      text-align: center;
      flex: 1;
    }
  }
}

.dynamic-follow {
  width: 55px;
  height: 25px;
  line-height: 25px;
  float: right;
  margin: 10px 0;
  font-size: 14px;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  color: red;
  border: 1px solid red;
}

.label {
  margin: 25px 15px;
}
.list-style{
  padding: 0 15px;
}
/deep/ .van-tabs--line .van-tabs__wrap {
  height: 20px;
}

/deep/ .van-tab--active {
  font-size: 18px;
  font-weight: bold;
}

/deep/ .van-tab {
  font-size: 17px;
  z-index: 99;
}
.clerkBox{
  border-bottom: 1px #f5f5f5 solid;
  font-size: 14px;
  padding: 15px;
}

.dynamic {
  width: 100%;
  padding-top: 15px;
  border-bottom: 1px solid #eeeeee;
}

.dynamic-head {
  width: 100%;
  height: 50px;
}

.dynamic-img {
  width: 50px;
  height: 50px;
  float: left;
}

.dynamic-img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.information {
  height: 50px;
  float: left;
  margin: 0 0 0 10px;
}

.dynamic-name {
  display: inline-block;
  height: 25px;
  line-height: 25px;
  float: left;
}

.dynamic-date {
  display: inline-block;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  text-align: center;
  color: #999999;
}

.dynamic-sex {
  margin-left: 5px;
  height: 25px;
  line-height: 25px;
  float: left;
}

.dynamic-sex .men {
  color: #10cafe;
}

.dynamic-sex .women {
  color: #e6a0df;
}

.dynamic-body {
  width: 100%;
}

.script {
  width: 100%;
  padding: 10px 0;
  word-wrap: break-word;
  font-size: 14px;
  color: #999999;
}

.audio-player {
  width: 100%;
  height: 25px;
  background: #54D3C3;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 9px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-size: cover;
  z-index: 3;

  .audio {
    width: 100%;
    padding: 0 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .wave {
      margin-left: 3px;
    }

    .duration {
      font-size: 8px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #fff;
    }
  }

  &.playing {
    .wave {
      @keyframes wave {
        from {
          height: 18px;
        }
        to {
          height: 12px;
        }
      }
      animation: wave .5s linear 0s infinite alternate;
    }
  }
}
.play-tubiao{
  width: 14px;
  line-height: 14px;
  font-size: 6px;
  text-align: center;
}
.play-a{
  color: #fff;
  vertical-align: middle;
}
.likes{
  margin-top: 5px;
  float: right;
}
.liked {
  color: #1cbbb4;
}
.like-num{
  margin-left: 5px;
  padding-top: 3px;
  float: right;
  height: 25px;
  line-height: 25px;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  padding: 10px 0;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);

  .bottom-button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: none;
    background: #54D3C3;
    color: white;
  }
}

</style>
